import { Link } from "react-router-dom";
import { Twitter} from 'react-bootstrap-icons';
export default function Team() {
  return (
    <>
      <div id="team" className="container-fluid">
        <h2 className="head_pt main_banner-heading">
          Meet our Designers & the Team
        </h2>
        <p className="para-sub team_para">
          Our Team having a ton of experience will provide you with the best
          quality you will <br /> be able to find. They are talented, motivated
          and ready to rock the NFT world with you.
        </p>
        <div className="row main_large_team">
          <div className="col-sm-7 team_info">
            <h1 className="banner-head billion_heading">
              Idea, concept and design
            </h1>
            <b></b>
            <p className="banner-para team_para">
              {/* The idea of Little Billionaires is based on a mixture of <br />
              the current NFT trends and something bold, something new <br />
              and unprecedented, which should reflect a new style and <br />a
              new idea. Not only a mix of photorealistic assets and <br />a main
              3D character varying positions and unique assets
              <br /> brings together elements that are in clear harmony */}
              The idea of <b>Little Billionaires</b> is based on a mixture of the
              current NFT trends and something bold, something new and
              unprecedented, which should reflect a new style and a new idea.
              Not only a mix of photorealistic assets and a main 3D character
              varying positions and unique assets brings together elements that
              are in clear harmony
            </p>
            <div>
              <ul className="social-team">
                <li className="social-team_list" onClick={()=>window.open('https://twitter.com/LittleBillions')}>
                  <Link to="/">
                    <img
                      src={"images/twit-head.png"}
                      className="head-social effecthov" alt="twit-head-imag"
                    />
                  </Link>
                </li>
                <li className="social-team_list" onClick={()=>window.open('https://www.instagram.com/littlebillionaires.io/')}>
                  <Link to="/">
                    <img
                      src={"images/insta-head.png"}
                      className="head-social effecthov" alt="insta-head-imag"
                    />
                  </Link>
                </li>
                <li className="social-team_list" onClick={()=>window.open('https://discord.gg/7UD5mSxSSW')}>
                  <Link to="/">
                    <img
                      src={"images/dis-head.png"}
                      className="head-social effecthov" alt="dis-head-imag"
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-sm-5 picture">
            {/* <img src={"images/new/12.png"} className="team_img floating" /> */}
            <p className="main_team_members">
              <div className="team_member">
                <img src={"images/new/Art_Director_Agent_Doomy.png"} alt="team-member-imag"></img>
                <strong onClick={()=>window.open('https://twitter.com/loomi_eth')}>Art Director  <Twitter size={13} color="#ffffff" /></strong>
                <span onClick={()=>window.open('https://twitter.com/loomi_eth')}>Agent Loomy</span>
                <div className="team_overlay"></div>
              </div>
              <div className="team_member">
                <img src={"images/new/Designer_Agent_Keedle.png"} alt="team-member-imag" onClick={()=>window.open('https://twitter.com/keedle_eth')}></img>
                <strong  onClick={()=>window.open('https://twitter.com/keedle_eth')}>Designer Agent <Twitter size={13} color="#ffffff" /></strong>
                <span  onClick={()=>window.open('https://twitter.com/keedle_eth')}>Agent Keedle</span>
                <div className="team_overlay"></div>
              </div>
            </p>
            <p className="main_team_members">
              <div className="team_member">
                <img src={"images/new/Community_Manager_Agent_Liam.png"} alt="team-member-imag" onClick={()=>window.open('https://twitter.com/liiam_eth')}></img>
                <strong  onClick={()=>window.open('https://twitter.com/liiam_eth')}>Community Manager  <Twitter size={13} color="#ffffff" /></strong>
                <span  onClick={()=>window.open('https://twitter.com/liiam_eth')}>Agent Liam</span>
                <div className="team_overlay"></div>
              </div>
              <div className="team_member">
                <img src={"images/new/IT_Director_Agent_Cozomo.png"} alt="team-member-imag"></img>
                <strong  onClick={()=>window.open('https://twitter.com/Cozomo_eth')}>IT Director  <Twitter size={13} color="#ffffff" /></strong>
                <span  onClick={()=>window.open('https://twitter.com/Cozomo_eth')}>Agent Cozomo</span>
                <div className="team_overlay"></div>
              </div>
            </p>
          </div>
        </div>
        <div className="row main_small_team" style={{display:"none"}}>
          <div className="col-sm-5 picture">
            {/* <img src={"images/new/12.png"} className="team_img floating" /> */}
            <p className="main_team_members">
              <div className="team_member">
                <img src={"images/new/Art_Director_Agent_Doomy.png"} alt="team-member-imag"></img>
                <strong onClick={()=>window.open('https://twitter.com/doome_eth')}>Art Director  <Twitter size={13} color="#ffffff" /></strong>
                <span onClick={()=>window.open('https://twitter.com/doome_eth')}>Agent Loomi</span>
                <div className="team_overlay"></div>
              </div>
              <div className="team_member">
                <img src={"images/new/Designer_Agent_Keedle.png"} alt="team-member-imag" onClick={()=>window.open('https://twitter.com/keedle_eth')}></img>
                <strong  onClick={()=>window.open('https://twitter.com/Cozomo_eth')}>Designer Agent <Twitter size={13} color="#ffffff" /></strong>
                <span  onClick={()=>window.open('https://twitter.com/Cozomo_eth')}>Agent Keedle</span>
                <div className="team_overlay"></div>
              </div>
            </p>
            <p className="main_team_members">
              <div className="team_member">
                <img src={"images/new/Community_Manager_Agent_Liam.png"} alt="team-member-imag" onClick={()=>window.open('https://twitter.com/liiam_eth')}></img>
                <strong  onClick={()=>window.open('https://twitter.com/Cozomo_eth')}>Community Manager  <Twitter size={13} color="#ffffff" /></strong>
                <span  onClick={()=>window.open('https://twitter.com/Cozomo_eth')}>Agent Liam</span>
                <div className="team_overlay"></div>
              </div>
              <div className="team_member">
                <img src={"images/new/IT_Director_Agent_Cozomo.png"} alt="team-member-imag"></img>
                <strong  onClick={()=>window.open('https://twitter.com/Cozomo_eth')}>IT Director  <Twitter size={13} color="#ffffff" /></strong>
                <span  onClick={()=>window.open('https://twitter.com/Cozomo_eth')}>Agent Cozomo</span>
                <div className="team_overlay"></div>
              </div>
            </p>
          </div>
          <div className="col-sm-7 team_info">
            <h1 className="banner-head billion_heading">
              Idea, concept and design
            </h1>
            <b></b>
            <p className="banner-para team_para">
              {/* The idea of Little Billionaires is based on a mixture of <br />
              the current NFT trends and something bold, something new <br />
              and unprecedented, which should reflect a new style and <br />a
              new idea. Not only a mix of photorealistic assets and <br />a main
              3D character varying positions and unique assets
              <br /> brings together elements that are in clear harmony */}
              The idea of <b>Little Billionaires</b> is based on a mixture of the
              current NFT trends and something bold, something new and
              unprecedented, which should reflect a new style and a new idea.
              Not only a mix of photorealistic assets and a main 3D character
              varying positions and unique assets brings together elements that
              are in clear harmony
            </p>
            <div>
              <ul className="social-team">
                <li className="social-team_list" onClick={()=>window.open('https://twitter.com/LittleBillions')}>
                  <Link to="/">
                    <img
                      src={"images/twit-head.png"}
                      className="head-social effecthov" alt="twit-head-imag"
                    />
                  </Link>
                </li>
                <li className="social-team_list" onClick={()=>window.open('https://www.instagram.com/littlebillionaires.io/')}>
                  <Link to="/">
                    <img
                      src={"images/insta-head.png"}
                      className="head-social effecthov" alt="insta-head-imag"
                    />
                  </Link>
                </li>
                <li className="social-team_list" onClick={()=>window.open('https://discord.gg/7UD5mSxSSW')}>
                  <Link to="/">
                    <img
                      src={"images/dis-head.png"}
                      className="head-social effecthov" alt="dis-head-imag"
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
